import { Component, OnInit } from '@angular/core';
import {MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { PayGuard } from '../pay.guard';
import { LocalService } from '../local.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {



  constructor(private _bottomSheetRef: MatBottomSheetRef<MatBottomSheet>,private router:Router,private log:AuthService
        ,private pay:PayGuard , private local:LocalService) { }

closeSheet(){
  this._bottomSheetRef.dismiss();
}

  logout(){
    this.log.googleLogoout().then(res => {
      this._bottomSheetRef.dismiss();

      this.router.navigate([''])
    }).catch(err => console.log(err))
  }

  ngOnInit(): void {
  
   this.local.removeObjFromStorage();
    this.pay.key=0;
  }

}
